import { AppBar } from '@psyomics/ui-components';
import { Outlet } from 'react-router-dom';

function PublicLayout() {
  return (
    <div className="flex min-h-dvh flex-col">
      <AppBar showMenu={false} />
      <main className="flex min-h-0 flex-1 flex-col">
        <Outlet />
      </main>
    </div>
  );
}

export { PublicLayout };
